<template>
  <div class="modal" v-show="show">
    <v-dialog v-model="value" persistent max-width="600px">
      <v-card>
        <v-toolbar color="red lighten-1 " dark>
          <v-toolbar-title class="headline"
            >{{ Headline }} {{ removeItem.name }}</v-toolbar-title
          >
        </v-toolbar>
        <v-card-text>
          <p>
            {{ WarningText }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark color="blue darken-1" @click="show = false">
            Ångra
          </v-btn>
          <v-btn color="red lighten-1" text dark @click="remove()">
            {{ Type != "Archive" ? "Ta bort" : "Arkivera" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  created() {},

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  name: "RemoveWindow",
  props: {
    value: {
      required: true,
    },
    removeItem: Object,
    WarningText: String,
    Headline: String,
    Type: String,
  },
  methods: {
    ...mapActions("mappings", ["archive"]),
    ...mapActions("cases", ["removeCase"]),
    ...mapActions("classesAP", ["removeAP"]),
    ...mapActions(["showSuccessSnackbar"]),
    ...mapActions("ehtmembers", ["removemember","removeActivity"]),
    ...mapActions("teachers", ["removeteacher"]),
    ...mapActions("extra", ["removeExtra"]),
    ...mapActions("whistles", ["removeWhistle"]),
    ...mapActions("feeling", ["removeFeeling"]),
    ...mapActions('violations', ['removeViolation']),

    remove() {
      if (this.Type == "AP") {
        this.removeAP(this.removeItem.id);
        this.showSuccessSnackbar(
          " Du har nu tagit bort åtgärdsprogrammet för " + this.removeItem.name
        );
      } else if (this.Type == "Lärare") {
        this.removeteacher(this.removeItem.id);
        this.showSuccessSnackbar(
          " Du har nu tagit bort läraren " + this.removeItem.name
        );
      } else if (this.Type == "Elevhälsoteam") {
        this.removemember(this.removeItem.id);
        this.showSuccessSnackbar(
          " Du har nu tagit bort elevhälsopersonalen " + this.removeItem.name
        );
      } else if (this.Type == "protokoll") {
        this.removeAP(this.removeItem.id);
        this.showSuccessSnackbar(
          " Du har nu tagit bort protokollet " + this.removeItem.name
        );
      } else if (this.Type == "Case") {
        this.removeCase(this.removeItem.id);
        this.showSuccessSnackbar(
          " Du har nu tagit bort ärendet för " + this.removeItem.name
        );
      } 
      else if (this.Type == "Extra") {
        this.removeExtra(this.removeItem.id);
        this.showSuccessSnackbar(
          "Du har nu tagit bort extraanpassningen för " + this.removeItem.name
        );
      } 
      else if (this.Type == "Nurse") {
         (this.removeItem)
        this.removeActivity(this.removeItem.id);
        this.showSuccessSnackbar("Elevärendet är hanterat.");
      } else if (this.Type == "Archive") {
        this.archive(this.removeItem);
        this.showSuccessSnackbar("Kartläggningen är arkiverad.");
      }
      else if (this.Type == "Whistle") {
      this.removeWhistle(this.removeItem.id);
        this.showSuccessSnackbar(
          "Du har nu tagit bort visslingen."
        );
      }
          else if (this.Type == "feeling") {
      this.removeFeeling(this.removeItem.id);
        this.showSuccessSnackbar(
          "Du har nu tagit bort måendekollen."
        );
      } 
      else if (this.Type == "violation") {
      this.removeViolation(this.removeItem.id);
        this.showSuccessSnackbar(
          "Du har nu tagit bort kränkningsanmälan."
        );
      }
      this.$emit('childToParent', false)
      this.show = false;
    },
  },
};
</script>




    <style lang="css" scoped>
.modal {
  background-color: rgba(0, 0, 0, 0.7);
}
</style>